import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldViewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-view',
	path: '/secure/admin/ViewFieldsScreen.jspa',
};
